import { useCallback } from "react"

import { ContractStatus } from "src/views/contracts/constants/status"
import { StatusState } from "src/views/contracts/types"

export const useGetContractStatus = () => {
    const getStatusState = useCallback(
        (status: string | null | undefined): StatusState => {
            if (status === null || status === undefined) return "other"

            const statusLower = status.toLowerCase()

            switch (statusLower) {
                case ContractStatus.ACTIVE:
                    return "positive"
                case ContractStatus.PENDING:
                    return "neutral"
                case ContractStatus.EXPIRED:
                    return "info"
                case ContractStatus.TERMINATED:
                    return "negative"
                default:
                    return "other"
            }
        },
        [],
    )

    return {
        getStatusState,
    }
}
